export default __webpack_public_path__ + "static/media/panda.ce9b1984.png";